/**
 * Created by Administrador on 25/09/2019.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('specialInvoiceService', specialInvoiceService);

    specialInvoiceService.$inject = ['$http', 'CONFIG', 'messageService'];


    function specialInvoiceService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FINANCE + '/' + CONFIG.API;

        var service = {
            getPageSpecialInvoices: getPageSpecialInvoices,
            getSpecialInvoice: getSpecialInvoice,
            saveSpecialInvoice: saveSpecialInvoice,
            annularSpecialInvoice: annularSpecialInvoice
        };

        return service;

        function getPageSpecialInvoices(page, size){
            return $http.get(urlBase + "/transaction-sale/page?page=" + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getSpecialInvoice(invoiceId){
            return $http.get(urlBase +"/transaction-sale/" + invoiceId)
                .then(function(response){
                    return response.data;
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function saveSpecialInvoice(specialInvoice){
            return $http.post(urlBase + "/transaction-sale", specialInvoice)
                .then(function(response){
                    messageService.registerUpdate('');
                    return response;
                })
                .catch(function(err){
                    messageService.registerUpdateError('')
                    return err;
                });
        }

        function annularSpecialInvoice(invoiceId){
            return $http.put(urlBase + "/transaction-sale/" + invoiceId + "/cancelSale", null)
                .then(function(response){
                    messageService.registerDelete('specialInvoices');
                    return response;
                })
                .catch(function(error){
                    messageService.registerDeleteError('specialInvoices');
                });
        }

    }
})();
